// BL-408 Multi-Company Sign-In, G1: the browser's only two calls into the server-side active company.
// The server decides (migration 239): mcs_set_active_company checks membership and MFA and writes the audit line;
// auth_org_id() re-checks on every request. The browser never stores or sends a company of its own here.
// Not wired into any screen yet; the switcher is G2/G3.

const ORG_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Server refusals (all SQLSTATE 42501) mapped to what the person should do next. Anything else is a plain failure.
const REFUSALS = [
    { match: /authenticator/i, reason: 'mfa_required' },
    { match: /sign in again/i, reason: 'sign_in_again' },
    { match: /not available/i, reason: 'not_available' },
];

function refusalReason(error) {
    if (!error) return null;
    const message = String(error.message || '');
    const hit = REFUSALS.find((entry) => entry.match.test(message));
    if (hit) return hit.reason;
    return error.code === '42501' ? 'not_available' : 'failed';
}

// Ask the server to move this sign-in session into a company. Resolves to
// { ok: true, orgId } or { ok: false, reason: 'mfa_required' | 'sign_in_again' | 'not_available' | 'failed' }.
export async function setActiveCompany(client, orgId) {
    if (!client || typeof client.rpc !== 'function') throw new TypeError('setActiveCompany needs a Supabase client');
    // Same answer as the server gives for a company that is not yours: never hint at what exists.
    if (typeof orgId !== 'string' || !ORG_ID.test(orgId)) return { ok: false, reason: 'not_available' };
    const { data, error } = await client.rpc('mcs_set_active_company', { p_org: orgId });
    if (error) return { ok: false, reason: refusalReason(error) };
    if (typeof data !== 'string' || data.toLowerCase() !== orgId.toLowerCase()) return { ok: false, reason: 'failed' };
    return { ok: true, orgId: data };
}

// The signed-in person's own companies, as the server sees them right now.
// Each item: { orgId, name, role, isActive, canEnter, mfaRequired }.
export async function listMyCompanies(client) {
    if (!client || typeof client.rpc !== 'function') throw new TypeError('listMyCompanies needs a Supabase client');
    const { data, error } = await client.rpc('mcs_my_companies');
    if (error) throw error;
    return (Array.isArray(data) ? data : []).map((row) => ({
        orgId: row.org_id,
        name: row.name,
        role: row.role,
        isActive: row.is_active === true,
        canEnter: row.can_enter === true,
        mfaRequired: row.mfa_required === true,
    }));
}
